module.exports = __webpack_public_path__ + "img/customer-img.8128e27d.png";